import { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import { useRadio } from "@/context/RadioContext";

const burst = () =>
  Array.from({ length: 10 }, (_, i) => {
    const a = (i / 10) * Math.PI * 2;
    return { id: `${Date.now()}-${i}`, x: `${Math.cos(a) * 46}px`, y: `${Math.sin(a) * 46}px` };
  });

export const FlameButton = ({ size = "md", testid = "flame-reaction-button" }) => {
  const { state, flame, playing, listenStart } = useRadio();
  const [, tick] = useState(0);
  useEffect(() => { const id = setInterval(() => tick((x) => x + 1), 1000); return () => clearInterval(id); }, []);
  const [parts, setParts] = useState([]);
  const [pop, setPop] = useState(false);
  const cur = state?.current;
  const done = cur?.my_flamed;
  const big = size === "lg";
  const wait = playing && !done && listenStart?.play === cur?.play_id ? Math.max(0, 30 - Math.floor((Date.now() - listenStart.at) / 1000)) : playing && !done ? 30 : 0;

  const onClick = async () => {
    if (!playing || wait > 0) return;
    if (await flame()) {
      setParts(burst());
      setPop(true);
      setTimeout(() => { setParts([]); setPop(false); }, 750);
    }
  };

  return (
    <button
      data-testid={testid}
      onClick={onClick}
      disabled={!cur}
      title={!playing ? "Press play to give Flames" : done ? "Flame given" : wait ? `Listen ${wait}s more to give a Flame` : "Give a Flame"}
      className={`relative inline-flex items-center gap-2 rounded-full border font-display font-bold transition-[background-color,border-color,transform] duration-200 hover:-translate-y-0.5
        ${big ? "px-6 py-3.5 text-base" : "px-3.5 py-2 text-sm"}
        ${done ? "bg-[#FF2E63] border-[#FF2E63] text-white glow-crimson" : "border-[#FF2E63]/50 text-[#FF2E63] hover:bg-[#FF2E63]/10"}
        ${(!playing || wait > 0) && !done ? "opacity-60" : ""}`}
    >
      <Flame className={`${big ? "h-6 w-6" : "h-4 w-4"} ${pop ? "flame-pop" : ""}`} fill={done ? "currentColor" : "none"} />
      <span data-testid="flame-count" className="font-mono">{cur?.flames ?? 0}</span>
      {wait > 0 && <span data-testid="flame-wait" className="font-mono text-[10px] opacity-80">{wait}s</span>}
      {parts.map((p) => (
        <span key={p.id} className="particle left-1/2 top-1/2" style={{ "--x": p.x, "--y": p.y }} />
      ))}
    </button>
  );
};
